module.exports = __webpack_public_path__ + "img/banner-stars.f586ecba.jpg";